import SpecFiles from "./SpecFiles";
export default SpecFiles;
